/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */
import { JSONTransformer } from '@atlaskit/editor-json-transformer';
var transformer = new JSONTransformer();
export function toJSON(node) {
  return transformer.encode(node);
}